import { extender } from "@shared/backend/class-extender";
import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { Team } from "../team";
import { TeamFieldConfigEntityConfig } from "./config";
import { TeamFieldConfigFilters } from "./filters";
import { TeamFieldConfigMethods } from "./methods";
import {
  SUB_CATEGORY_FIELD_INPUT_TYPES,
  type SubCategoryFieldInputType,
} from "../sub-category-field-config";

@HyperEntity("team-field-config", TeamFieldConfigEntityConfig)
export class TeamFieldConfig extends extender(
  TeamFieldConfigFilters,
  TeamFieldConfigMethods,
) {
  @Fields.id()
  id = "";

  @Fields.string({ dbName: "team_id" })
  teamId = "";

  @Relations.toOne(() => Team, "teamId")
  team?: Team;

  @Fields.string()
  field = "";

  @Fields.string()
  label = "";

  @Fields.boolean({ dbName: "is_required" })
  isRequired = false;

  @Fields.string({ dbName: "default_value", allowNull: true })
  defaultValue: string | null = null;

  @Fields.literal(() => SUB_CATEGORY_FIELD_INPUT_TYPES)
  type: SubCategoryFieldInputType = "TEXT";

  @Fields.boolean({ dbName: "append_to_description" })
  appendToDescription = false;

  @Fields.json<string[]>()
  options: string[] = [];

  @Fields.number()
  order = 0;

  @Fields.boolean({ dbName: "is_visible" })
  isVisible = true;

  @Fields.createdAt({ dbName: "created_at" })
  createdAt = new Date();

  @Fields.updatedAt({ dbName: "updated_at" })
  updatedAt = new Date();
}
